module.exports = __webpack_public_path__ + "static/media/loveSelected.71980337.webp";